import type { PayrollRosterMember } from "@/payroll/roster/types";
import { USER_ROLES } from "@/user/constants";
import type { StAdjustmentsPreviewUser } from "./types";

// Live rollups use numeric ServiceTitan ids. Normalize the
// roster once so names cannot disappear because an id carries whitespace or
// leading zeroes in the roster payload.
export const buildTechnicianNameMap = (
  members: PayrollRosterMember[] | undefined,
) => {
  const names = new Map<number, string>();

  members?.forEach((member) => {
    const rawEmployeeId = member.service_titan_employee_id?.trim();
    const name = member.display_name?.trim();
    const employeeId = Number(rawEmployeeId);

    if (
      !rawEmployeeId ||
      !name ||
      !Number.isSafeInteger(employeeId) ||
      employeeId <= 0 ||
      names.has(employeeId)
    ) {
      return;
    }

    names.set(employeeId, name);
  });

  return names;
};

// Preview names come from current business users, independently of the roster.
export const buildPreviewTechnicianNameMap = (
  users: StAdjustmentsPreviewUser[] | undefined,
) => {
  const names = new Map<number, string>();

  users?.forEach((user) => {
    const rawEmployeeId = user.crm_external_id?.trim();
    const employeeId = Number(rawEmployeeId);
    const name = [user.first_name?.trim(), user.last_name?.trim()]
      .filter(Boolean)
      .join(" ");

    if (
      user.role !== USER_ROLES.TECH ||
      user.discarded_at ||
      !name ||
      !rawEmployeeId ||
      !/^\d+$/.test(rawEmployeeId) ||
      !Number.isSafeInteger(employeeId) ||
      employeeId <= 0 ||
      names.has(employeeId)
    ) {
      return;
    }

    names.set(employeeId, name);
  });

  return names;
};
